import { Directive, ElementRef, output, signal, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[ms-in-view-port]'
})
export class InViewPortDirective implements AfterViewInit, OnDestroy {
  public inViewPort = output<void>();

  /**
   * Whether the host is on screen right now, as opposed to the `inViewPort` output which only fires
   * on the *transition* into view. Consumers that need to know "is it still sitting there visible?"
   * — rather than "did it just appear?" — read this instead. It accounts for clipping by scrolling
   * or collapsed ancestors, which a bounding-box check would miss.
   */
  public isInViewPort = signal(false);

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) { }

  public ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.isInViewPort.set(entry.isIntersecting);

        if (entry.isIntersecting === true) {
          this.inViewPort.emit();
        }
      });
    });
    this.observer.observe(this.el.nativeElement);
  }

  public ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

}
